/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesGoCampaign_PoliticalDistricts.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Political District Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, July 10, 2019 - 12:15:48 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      07/10/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const GoCampaign_PoliticalDistrictList = Loadable({
    loader: () => import('../containers/GoCampaign_PoliticalDistricts/GoCampaign_PoliticalDistrictListContainer'),
    loading: Loading,
});

export const GoCampaign_PoliticalDistrictForm = Loadable({
    loader: () => import('../containers/GoCampaign_PoliticalDistricts/GoCampaign_PoliticalDistrictEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesGoCampaign_PoliticalDistricts.js